import React from 'react';


class AudioPlayer extends React.Component {

    constructor(props, playButton, playBar, song) {
        super(props);

        this.playButton = playButton;
        this.playBar = playBar;
        this.song = song;

        this.playAudio = null;
        this.playBarAudio = null;
        this.audio = null;

        this.play = this.play.bind(this);
        this.stop = this.stop.bind(this);
        this.getNormalizedTime = this.getNormalizedTime.bind(this);
    }

    init() {
    
        this.playAudio = document.getElementById(this.playButton);
        this.playBarAudio = document.getElementById(this.playBar);
        this.audio = new Audio(this.song);
    }     

    play() {       

        if (this.audio.paused) {
            this.audio.play();

            if (this.playAudio != null) {
                this.playAudio.style.backgroundImage = "url('img/pause.svg')";                
            }
        } else {
            this.audio.pause();

            if (this.playAudio != null) {
                this.playAudio.style.backgroundImage = "url('img/play.svg')" ;              
            }
        }
    }

    stop() {
        this.audio.pause();
        this.audio.currentTime = 0;

        if (this.playAudio != null) {
            this.playAudio.style.backgroundImage = "url('img/play.svg')" ;              
        }
    }

    getNormalizedTime() {
        if (this.audio == null) {
            return 0;
        }

        return this.audio.currentTime / this.audio.duration;
    }
    
    
}

export default AudioPlayer;
